/**
 * The clock times the time pickers offer as presets.
 *
 * Kept out of the component so "tomorrow morning" means the same thing
 * wherever it is offered — sending a message later, and being reminded about
 * one — and so neither file has to re-derive it.
 */

/** Next occurrence of `hour` local time, today if it has not passed. */
export function nextAt(hour: number, daysAhead = 0): Date {
  const date = new Date();
  date.setSeconds(0, 0);
  date.setMinutes(0);
  date.setHours(hour);
  if (daysAhead > 0 || date.getTime() <= Date.now()) {
    date.setDate(date.getDate() + Math.max(1, daysAhead));
  }
  return date;
}

/** Next Monday at `hour`. */
export function nextMonday(hour: number): Date {
  const date = nextAt(hour);
  // 1 = Monday; step forward until we land on it.
  while (date.getDay() !== 1) date.setDate(date.getDate() + 1);
  return date;
}
